import React from 'react'
import { Modal } from 'react-bootstrap'

interface AppModalProps {
    isShowModal: boolean;
    handleCloseModal: (toggle: boolean) => void;
    children: React.ReactNode;
    title?: React.ReactNode;
    size?: 'sm'|'xl'|'lg'|'';
}

export const AppModal = ({children, title, size, isShowModal, handleCloseModal}: AppModalProps) => {
    const modalSize = size ? size : undefined
    return (
        <Modal
            size={modalSize}
            show={isShowModal}
            onHide={() => handleCloseModal(false)}
            backdrop="static"
            keyboard={false}
            aria-labelledby="app-modal"
        >
        <Modal.Header closeButton
            style={{
                paddingBottom: 0,
                paddingTop: '0.5rem',
                borderBottom: 'none'
            }}
        >{title ? title : ''}&nbsp;</Modal.Header>
        <Modal.Body
            style={{
                paddingTop: 0
            }}
        >{ children }</Modal.Body>
      </Modal>
    )
}
